// useIsMobile.js — hook partagé : vrai sous 768px. À placer dans src/hooks/
// (ou ajustez les imports des wrappers Responsive*).
import { useEffect, useState } from "react";

const QUERY = "(max-width: 768px)";
const match = () => typeof window !== "undefined" && window.matchMedia(QUERY).matches;

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(match);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const on = (e) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return isMobile;
}
